<template>
        <router-link tag="li" class="nav-item nav-dropdown" :to="url"
          :id = '"router-link-dropdown-sidebar" + label'>
            <div class="nav-link nav-dropdown-toggle" @click="handleClick">
              <em :class="classIcon"></em> {{ label }}
              <span
                v-if="this.label == 'Общение'  && unreadChats > 0"
                class="unreadChatsNotifier">
              </span>
              <span
                v-if="isTesting && !isTestOk
                && (hasRole('classroom-teacher') || hasRole('content-manager'))"
                class="testNotOkNotifier">
              </span>
            </div>
            <b-nav class="nav-dropdown-items">
                <slot></slot>
            </b-nav>
        </router-link>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'SidebarNavDropdown',
  data() {
    return {
      isOpen: false,
      timeForExpireCookie: '1d' // y, m, d, h, min, s
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    isTesting: {
      type: Boolean,
      default() {
        return false
      }
    },
    isTestOk: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    classIcon() {
      return [
        'nav-icon',
        this.icon
      ]
    },
    ...mapGetters({
      unreadChats: 'chats/getUnreadChats',
      hasRole: 'currentUser/hasRole'
    })
  },
  mounted() {
    const routerLink = document.getElementById(`router-link-dropdown-sidebar${this.label}`)
    if (!this.$cookies.isKey(this.label)) {
      if (!this.$route.path.includes('courses') && !this.$route.path.includes('education')) {
        this.$cookies.set(this.label, false, this.timeForExpireCookie)
      }
      if (routerLink.classList.contains('open')) {
        routerLink.classList.remove('open')
      }
      this.isOpen = false
    } else if (this.$cookies.get(this.label) === 'true') {
      if (!routerLink.classList.contains('open')) {
        routerLink.classList.add('open')
      }
      this.isOpen = true
    } else {
      if (routerLink.classList.contains('open')) {
        routerLink.classList.remove('open')
      }
      this.isOpen = false
    }
  },
  methods: {
    handleClick(e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
      this.isOpen = !this.isOpen
      if (!this.$route.path.includes('courses') && !this.$route.path.includes('education')) {
        this.$cookies.set(this.label, this.isOpen, this.timeForExpireCookie)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../../../sass/vendor/bootstrap/variables";

  .unreadChatsNotifier {
    height: 8px;
    width: 8px;
    background-color: $blue;
    border-radius: 50%;
    display: inline-block;
    margin-left: 10px;
    margin-top: 1px;
  }

  .testNotOkNotifier {
    height: 8px;
    width: 8px;
    background-color: $red;
    border-radius: 50%;
    display: inline-block;
    margin-left: 10px;
    margin-top: 1px;
  }
  .sidebar .nav-dropdown-toggle:before {
    transform: rotate(-90deg);
  }
  .sidebar .nav-dropdown.open > .nav-dropdown-toggle::before {
    transform: rotate(90deg) !important;
  }

  .sidebar .nav-dropdown {
    border-left: none !important;
  }
</style>
